<script>
export default {
  name: "DidoMillesimeInputFilterSimple",
};
</script>

<script setup>
import { ref, computed, watch } from "vue";
import { apiValueToLocaleString } from "../../../utils";

// define Props
const props = defineProps({
  modelValue: { type: String, required: false, default: "" },
  label: { type: Boolean, required: true },
  type: { type: String, required: true },
});

// define watchers
watch(
  () => [props.modelValue],
  () => (inputValue.value = props.modelValue ? [props.modelValue] : []),
);

// define Emits
const emit = defineEmits(["update:model-value"]);

// define reactive data
const inputValue = ref(props.modelValue ? [props.modelValue] : []);

// computed data to check if it's a number value
const isNumber = computed(() => ["number", "integer"].includes(props.type));

const formatSingle = (val) =>
  val && isNumber.value
    ? String(val).replace(/,/g, ".").replace(/\s/g, "")
    : val;
// define computed value for formatting input value
const formattedValue = computed(() =>
  inputValue.value.map((val) => formatSingle(val)).join("$SEPARATOR$"),
);
</script>

<template>
  <QSelect
    v-model="inputValue"
    dense
    square
    outlined
    stack-label
    use-input
    hide-dropdown-icon
    class="dido-millesimefilter-simple"
    :label="label && !inputValue.length ? 'Entrez une valeur' : ''"
    multiple
    :max-values="1"
    :readonly="!!inputValue.length"
    new-value-mode="add-unique"
    @update:model-value="emit('update:model-value', formattedValue)"
  >
    <template #selected-item="{ removeAtIndex, index, tabindex, opt }">
      <QChip
        removable
        :label="apiValueToLocaleString(opt, props.type)"
        size="sm"
        color="secondary"
        text-color="black"
        :tabindex="tabindex"
        class="text-small text-bold"
        @remove="removeAtIndex(index)"
      />
    </template>
  </QSelect>
</template>

<style lang="sass" scoped>
.dido-millesimefilter-simple
  min-width: 150px
</style>
